import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculationResponse } from '../../../../../../../common/dist/angular/responses/calculation.response';
import {
  CalculationKeynameEnum,
} from '../../../../../../../common/dist/angular/enums/calculations/calculation-keyname.enum';
import {
  ExportModalSalaryDividendComponent,
} from '../components/export-modal/salary-dividend/export-modal-salary-dividend.component';
import { LoggingService } from '../../core/services/logging.service';
import { ExportModalBase } from '../components/export-modal/export-modal.base';

@Injectable()
export class ExportModalFactory {
  constructor(
    public modalService: NgbModal,
    private readonly loggingService: LoggingService,
  ) {
  }

  openExportModal(calculation: CalculationResponse) {
    let exportModalComponent;

    switch (calculation.calculationKeyname) {
      case CalculationKeynameEnum.SalaryDividend:
      case CalculationKeynameEnum.SalaryDividendSimulation:
        exportModalComponent = ExportModalSalaryDividendComponent;
        break;
      case CalculationKeynameEnum.Section84_1:
    }

    if (exportModalComponent === null) {
      this.loggingService.error('There are no export modals defined for keyname: \'' + calculation.calculationKeyname + '\'');
      return;
    }

    const modal = this.modalService.open(exportModalComponent, {
      size: 'xl',
    });
    (modal.componentInstance as ExportModalBase).calculationResponse = calculation;
    modal.closed.subscribe(async result => {
      if (result === true) {
        return;
      }
    });

    return;
  }
}
